import { Component, OnInit } from '@angular/core';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import { PaymentsService } from '../../../shared/services/pubServices/payments.service';
import { Method, Payterm, Preferred } from '../../../models/pubModel/method.model';
import { SharedService } from 'src/app/shared/services/sharedServices/shared.service';
import { Page, PageClass } from 'src/app/shared/filters/filters';
import { browserRefresh } from '../../../app.component';
import { Subscription } from 'rxjs'
import { SignalrService } from 'src/app/shared/services/websecket/signalr.service';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pub-payments-component',
  templateUrl: './payments-component.html',
  styleUrls: ['./payments-component.scss'],
})

export class paymentsComponent implements OnInit {
  public browserRefresh: boolean;
  conversionActivated: Subscription;

  payoutsData: any;
  chartData: any;
  chartTotal: number;

  // chart options
  chartOptionCurrent: any;
  chartOptionPending: any;
  chartOptionTotal: any;
  chartOptionFee: any;
  
  active = 'payments';
  active1 = 'Wire';

  countryData: any;
  method = new Method();
  payout = new Payterm();
  prefer = new Preferred();
  flag: any;
  page = new Page();
  filter = new PageClass();

  pageSizeDefinition = 9;
  // chart
  pieChartData: any;

  ColumnMode = ColumnMode;

  constructor(private toastrService: ToastrService,
              private paymentsService: PaymentsService,
              private sharedServices: SharedService,
              private signalrService: SignalrService ) {
      this.page.pageNumber = 1;
      this.page.size = this.pageSizeDefinition;
  }

  ngOnInit() {
    // aktywacja obserwatora
    this.conversionActivated= this.signalrService.newConversionActivated.subscribe((id)=>{
      if(id==1){
        this.getPaymentsDetails();
      }
    })

    // weryfikacja czy nastąpiło refreshe page (F5)
    this.browserRefresh = browserRefresh;
    if(this.browserRefresh)
    {
      this.signalrService.startConnection();
      this.signalrService.newConversionListener();
    }

    this.getCountries();
    this.getPaymentsDetails();
    this.getChartBalance();
    this.setPage({ offset: 0 });
  }

  getCountries(): void {
    this.sharedServices.getAllCountries()
    .subscribe(
     data => {
       this.countryData = data.data.countries;
     },
     error => {
       console.log(error);
     });
  }

  setFlag(event){
    this.flag = this.countryData[this.method.wireBankCountryId-1].alpha2Code;
  }
  
  getPaymentsDetails(): void {
    this.paymentsService.getPaymentsDetails()
    .subscribe(
      data => {
        this.payout.preffered = data.data.prefferedPayoutMethod.name;
        this.payout.payTerm = data.data.payoutTerm.name;
        this.payout.minAmount = data.data.minAmount;
        this.payout.currentRevenue = data.data.currentRevenue;
        this.payout.payoutDate = data.data.nextPayoutDate;
        this.payout.wireFee = data.data.payoutMethodDetails.wire.paymentFeeForEachRequest;
        this.payout.payoneerFee = data.data.payoutMethodDetails.payoneer.paymentFeeForEachRequest;
        this.payout.payPalFee = data.data.payoutMethodDetails.payPal.paymentFeeForEachRequest;

        this.method.wireAccountHolder = data.data.payoutMethodDetails.wire.accountHolder;
        this.method.wireBankCountryId = data.data.payoutMethodDetails.wire.bankCountry.id;
        this.method.wireBankName = data.data.payoutMethodDetails.wire.bankName;
        this.method.wireIban = data.data.payoutMethodDetails.wire.iban;
        this.method.wireSwift = data.data.payoutMethodDetails.wire.swift;
        this.method.payoneerEmail = data.data.payoutMethodDetails.payoneer.email;
        this.method.payPalEmail = data.data.payoutMethodDetails.payPal.email;
      },
      error => {
        console.log(error);
      });
  }

  setPage(pageInfo){
    this.filter.pageNumber = pageInfo.offset+1;
    this.filter.pageSize = this.pageSizeDefinition;

    this.paymentsService.getPayments(this.filter)
    .subscribe(
     data => {
      this.page.totalElements = data.totalRecords;
      this.page.totalPages = data.totalPages;
      this.page.pageNumber = data.pageNumber-1;
      this.payoutsData = data.data;
     },
     error => {
       console.log(error);
     });
  }

  getChartBalance(){
    this.paymentsService.getBalance()
    .subscribe(
     data => {
      this.chartData = data.data.data;
      this.chartTotal = data.data.data[0].value;

      this.chartOptionTotal = this.roundTo(data.data.data[0].value, 2);
      this.chartOptionCurrent = this.roundTo(data.data.data[1].value, 2);
      this.chartOptionFee = this.roundTo(data.data.data[2].value, 2);
      this.chartOptionPending = this.roundTo(data.data.data[3].value, 2);
     },
     error => {
       console.log(error);
     });
  }

  onTab(changeEvent: NgbNavChangeEvent){
    if (changeEvent.nextId == "payments") {
      // Action for first tab PAYOUTS
      this.getChartBalance();
    }

    if (changeEvent.nextId == "method") {
      // Action for second tab METHOD

      this.flag = this.countryData[this.method.wireBankCountryId-1].alpha2Code;
    }

  }

  setPreffered(event){
    if(this.payout.preffered=='Wire')
      this.prefer.prefferedPayoutMethod=1;

    if(this.payout.preffered=='Payoneer')
      this.prefer.prefferedPayoutMethod=2;

    if(this.payout.preffered=='PayPal')
      this.prefer.prefferedPayoutMethod=3;

    this.paymentsService.updatePreffered(this.prefer)
    .subscribe(
      data => {
      this.toastrService.success('New preffered payout configured.', 'Success !');
      },
      error => {
        console.log(error);
      });
  }

  onSave(){
    this.paymentsService.updateMethod(this.method)
    .subscribe(
      response => {
        this.toastrService.success('Updated payment method.', 'Success !');
      },
      error => {
        console.log(error);
      });

  }

  roundTo(num: number, places: number) {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
  }

  getnextpaydayDate(day: any) {
    var date1: any;
    var date2: any;

    date1 = new Date(day);
    date2 = new Date();

    var diffInMs = Math.abs(date1 - date2);

    return  Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
  }
}
